import Vue from 'vue';
import VueRouter from 'vue-router';
import { isMobile } from 'mobile-device-detect';

import Home from './views/app/home/Home.vue';
import MobileHome from './views/mobile/home/Home.vue';

Vue.use(VueRouter);

const widthScreen = window.innerWidth
|| document.documentElement.clientWidth
|| document.body.clientWidth;

const routes = [
  {
    path: '/',
    name: 'index',
    component: isMobile && widthScreen < 1024 ? MobileHome : Home,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
